import { User } from '../types/user';
import { http } from '../util/https.util';

const LOGIN_URL = '/api/login';
const RESET_PASSWORD_URL = '/api/password/reset';
const ME_URL = '/api/user/me';
const LOGOUT_URL = '/api/logout';

export namespace AuthenticationRequest {
  export interface AuthenticationToken {
    accessToken: string;
    refreshToken: string;
    tokenType: string;
    expiresIn: number;
    scope: string;
  }

  export enum ResultType {
    normal = 'normal',
    authenticationCodeRequired = 'authenticationCodeRequired',
  }

  export interface SignInPayload {
    email: string;
    password: string;
    code?: string;
  }

  export interface SignInResponse {
    user: User;
    token: AuthenticationToken;
    type: ResultType;
  }

  export const login = async (payload: SignInPayload): Promise<SignInResponse> => {
    return (await http.post(LOGIN_URL, payload)).data;
  };

  export interface ResetPasswordPayload {
    email: string;
  }

  export const resetPassword = async (payload: ResetPasswordPayload): Promise<boolean> => {
    return (await http.post(RESET_PASSWORD_URL, payload)).data;
  };

  export const me = async (): Promise<User> => {
    return (await http.get(ME_URL)).data;
  };

  export const logout = async (): Promise<void> => {
    return http.post(LOGOUT_URL);
  };
}
